module.exports = "<div class=\"pointer target-select\" \n\tng-disabled = \"isCurrentTarget(row._id)\" title=\"{{row.full_name}}\">{{row.full_name}}</div>"